import React, { useState } from 'react';
import "./Navigation.css"
import Logo from "../assets/images/new_logo2.png"
import { FaBars, FaTimes } from 'react-icons/fa';
import { NavLink } from "react-router-dom";

const Navigation = () => {
    const [showMenu, setShowMenu] = useState(false);
    const handleToggle = () => {
        setShowMenu(!showMenu);
    };

    const handleLinkClick = () => {
        window.scrollTo(0, 0);
        setShowMenu(false);
    };
    return (
        <div className="navbar_container">
            <div className="navbar__logo">
                <NavLink to="/" onClick={() => window.scrollTo(0, 0)}>
                    <img src={Logo} alt="nav_logo" className="logo-image" />
                </NavLink>
            </div>

            <button className="navbar__toggle" onClick={handleToggle}>
                {showMenu ? <FaTimes /> : <FaBars />}
            </button>

            <div className={`main_nav ${showMenu ? 'show' : ''}`}>
                <div className="nav__content">
                    <div className="main_nav_logo">
                        <NavLink to="/" onClick={handleLinkClick}>
                            <img src={Logo} alt="nav_logo" className="logo-image" />
                        </NavLink>

                    </div>

                    <div className="nav__list">
                        <div className="nav__item">
                            <NavLink to="/"  onClick={handleLinkClick}>
                                Home
                            </NavLink>
                        </div>

                        <div className="nav__item dropdown_container">
                            <div className="dropdown__link">
                                <NavLink to="/research"  onClick={handleLinkClick}>
                                    Research Areas <i className="bx bx-chevron-down dropdown__icon"></i>
                                </NavLink>
                            </div>


                            <div className="dropdown__menu">
                                <div className="dropdown__item">
                                    <NavLink to="/research/hydrologic-monitoring-and-prediction"  onClick={handleLinkClick}>
                                        Hydrologic Monitoring and Prediction
                                    </NavLink>
                                </div>
                                <div className="dropdown__item">
                                    <NavLink to="/research/climate-and-urban-systems"  onClick={handleLinkClick}>
                                        Climate and Urban Systems
                                    </NavLink>
                                </div>
                                <div className="dropdown__item">
                                    <NavLink to="/research/climate-extremes-understanding"  onClick={handleLinkClick}>
                                        Climate Extremes
                                    </NavLink>
                                </div>
                                <div className="dropdown__item">
                                    <NavLink to="/research/hydrologic-sensitivity-and-change"  onClick={handleLinkClick}>
                                        Understanding Hydrologic Sensitivity and Change
                                    </NavLink>
                                </div>
                            </div>
                        </div>

                        <div className="nav__item dropdown_container">
                            <div className="dropdown__link">
                                <NavLink to="/people"  onClick={handleLinkClick}>
                                    People <i className="bx bx-chevron-down dropdown__icon"></i>
                                </NavLink>
                            </div>

                            <div className="dropdown__menu">
                                <div className="dropdown__item">
                                    <NavLink to="/people/current"  onClick={handleLinkClick}>
                                        Current Members
                                    </NavLink>
                                </div>
                                <div className="dropdown__item">
                                    <NavLink to="/people/interns"  onClick={handleLinkClick}>
                                        Interns
                                    </NavLink>
                                </div>

                                <div className="dropdown__item">
                                    <NavLink to="/people/alumni"  onClick={handleLinkClick}>
                                        Alumni
                                    </NavLink>
                                </div>
                                <div className="dropdown__item">
                                    <NavLink to="/people/gallery"  onClick={handleLinkClick}>
                                        Photo Gallery
                                    </NavLink>
                                </div>

                            </div>
                        </div>
                        <div className="nav__item dropdown_container">
                            <div className="dropdown__link">
                                <NavLink to="/publications"  onClick={handleLinkClick}>
                                    Publications <i className="bx bx-chevron-down dropdown__icon"></i>
                                </NavLink>
                            </div>
                            <div className="dropdown__menu">

                                <div className="dropdown__item">
                                    <NavLink to="/publications/journal-articles"  onClick={handleLinkClick}>
                                        Journal Articles
                                    </NavLink>
                                </div>
                                <div className="dropdown__item">
                                    <NavLink to="/publications/conference-presentations"  onClick={handleLinkClick}>
                                        Conferences, Abstracts, and Presentations
                                    </NavLink>
                                </div>
                                <div className="dropdown__item">
                                    <NavLink to="/publications/books-expository-and-review-articles"  onClick={handleLinkClick}>
                                        Books, Expository and Review Articles
                                    </NavLink>
                                </div>
                                <div className="dropdown__item">
                                    <NavLink to="/publications/invited-papers"  onClick={handleLinkClick}>
                                        Invited papers in published conference
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                        <div className="nav__item">
                            <NavLink to="/data"  onClick={handleLinkClick}>
                                Data
                            </NavLink>
                        </div>
                        <div className="nav__item">
                            <NavLink to="/news"  onClick={handleLinkClick}>
                                News
                            </NavLink>
                        </div>

                        <div className="nav__item dropdown_container">
                            <div className="dropdown__link">
                                <NavLink to="/data-portals"  onClick={handleLinkClick}>
                                    Data Portals <i className="bx bx-chevron-down dropdown__icon"></i>
                                </NavLink>

                            </div>
                            <div className="dropdown__menu">

                                <div className="dropdown__item">
                                    <a href="https://indiadroughtmonitor.in/"  target={"_blank"} rel="noreferrer">
                                        India Drought Monitor
                                    </a>
                                </div>
                                {/* <div className="dropdown__item">
                                    <a href="https://sites.google.com/iitgn.ac.in/expforecastlandsurfaceproducts/home?authuser=0"  target={"_blank"} rel="noreferrer">
                                        EFLSP (IMD)
                                    </a>
                                </div> */}
                                <div className="dropdown__item">
                                    <a href="https://indiadroughtatlas.in/"  target={"_blank"} rel="noreferrer">
                                        India Drought Atlas
                                    </a>
                                </div> 
                                <div className="dropdown__item">
                                    <a href="https://indiafloodatlas.in/"  target={"_blank"} rel="noreferrer">
                                        India Flood Atlas
                                    </a>
                                </div> 
                                <div className="dropdown__item">
                                    <a href="https://geoportalofindiandams.github.io/GeoID/"  target={"_blank"} rel="noreferrer">
                                        Geoportal of Indian Dams
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="nav__item">
                            <NavLink to="/contact"  onClick={handleLinkClick}>
                                Contact Us
                            </NavLink>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    )
}

export default Navigation
